
import React from 'react';
import { Button } from 'react-bootstrap';
import Spinner from 'react-spinkit';
import { compose, lifecycle, withStateHandlers } from 'recompose';

const LoadingButton = ({ loading, text, onClick, className, type, clicked, setClicked, disabled = false, loadingText, ...props }) => {
  const handleClick = () => {
    if (!clicked) {
      setClicked(true)
    }
    if (onClick) {
      onClick()
    }
  }

  return (clicked && loading) ?
    <Button disabled={disabled} className={className} {...props}><Spinner name='circle' className='spinner' fadeIn='none' />{loadingText}</Button> :
    <Button disabled={disabled} className={className} onClick={handleClick} type={type} {...props}>{text}</Button>
}
export default compose(
  withStateHandlers(
    {
      clicked: false
    },
    {
      setClicked: () => (clicked) => ({ clicked })
    }
  ),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (prevProps.loading && !this.props.loading) {
        this.props.setClicked(false)
      }
    }
  })
)(LoadingButton)


// WEBPACK FOOTER //
// ./src/containers/components/LoadingButton.js